import { RefundsFilterSheetComponent } from '../shared/ui/refunds-filter-sheet/refunds-filter-sheet.component';
import { Component, ViewChild, OnDestroy} from '@angular/core';
import { AccountingRefund } from '../shared/models/';
import { AppPageComponent } from '../../shared/ui';
import { AccountingRefundFilter, AccountingService } from '../shared';
import { FormGroup } from '@angular/forms';
import { UserService, Store, StoreHelper } from '../../shared/services';
import { HeaderAction, TopLevelComponent } from '../../shared/models';
import { Subscription } from 'rxjs';

@Component({
    template: require('./accounting-refunds.component.pug'),
    styles: [
        require('./accounting-refunds.component.scss')
    ],
})
export class AccountingRefundsComponent extends TopLevelComponent implements OnDestroy {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(RefundsFilterSheetComponent) filterSheet;

    fg = new FormGroup({});
    refunds: Array<AccountingRefund> = [];

    private _refundsSub: Subscription;
    private _searchAction = { id: 'search', icon: 'search' };
    private _refundsFilter: AccountingRefundFilter;
    private _filterReady: boolean = false;

    public empty = false;

    constructor(
        private _accountingRefundsService: AccountingService,
        store: Store,
        storeHelper: StoreHelper,
        userService: UserService
    ) {
        super(store, storeHelper, userService);

        // set title and actions
        this.headerTitle = 'Refunds';
        this.headerActions = [this._searchAction];
        this.subscribeToHeaderActions(this._reactToHeaderAction);
    }

    ngOnDestroy() {
        this._refundsSub.unsubscribe();
    }

    onFilterChanged(filter: AccountingRefundFilter) {
        this._refundsFilter = filter;

        if (this._refundsFilter.locationsSelection.locations.length > 0) {
            this._loadRefundsReport();

        } else {
            this._resetRefundsData();

            this.empty = true;
            setTimeout(() => this.filterSheet.toggle(), 1500);

            if (this._filterReady) {
                this.filterSheet.toggle();
            }
            this._filterReady = true;
        }
    }

    private _reactToHeaderAction(action: HeaderAction) {
        if (action.id === this._searchAction.id) {
            this.filterSheet.toggle();
        }
    }

    private _loadRefundsReport() {
        let that = this;
        this.empty = false;
        this.appPage.activatePreloader();

        this._refundsSub = this._accountingRefundsService.getRefundsReport(this._refundsFilter)
            .subscribe(refunds => {
                that.refunds = refunds;

                that.appPage.deactivatePreloader();
                this.empty = refunds.length <= 0;

                if (this.empty) {
                    setTimeout(() => this.filterSheet.toggle(), 1500);
                }

            });
        if (this._filterReady) {
            this.filterSheet.toggle();
        }
        this._filterReady = true;
    }

    private _resetRefundsData() {
        this.refunds = [];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/refunds/accounting-refunds.component.ts